<template>
  <div
    :id="id"
    class="base-hotspot-wrapper">
    <div
      class="base-hotspot">
      <div class="oval-spot"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseHotspot',
    props: {
      id: {
        type: String,
        default: ''
      },
    },
  };
</script>

<style lang="scss">
  @keyframes pulse {
    from {
      transform: scale(1);
      opacity: 1;
    }
    to {
      transform: scale(2.666);
      opacity: 0;
    }
  }
  .base-hotspot-wrapper {
    cursor: pointer;
    .base-hotspot {
      cursor: pointer;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: rgba(247, 181, 0, 0.2); // same with background-color: #f7b500 and opacity 0.2
      position: relative;
      .oval-spot {
        width: 12px;
        height: 12px;
        background-color: rgba(247, 181, 0, 0.8);
        position: absolute;
        border-radius: 12px;
        top: 10px;
        left: 10px;
        animation: pulse 2s 1s infinite ease-out
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/base-hotspot/BaseHotspot.vue